<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">状态：</span>
          <div style="width: 180px">
            <el-select v-model="query.status" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="item in statusOptions" :key="String(item.value)" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
          <div style="width: 220px">
            <el-input v-model="query.orderNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">买家昵称：</span>
          <div style="width: 130px">
            <el-input v-model="query.buyerNickName" placeholder="可选" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">卖家昵称：</span>
          <div style="width: 130px">
            <el-input v-model="query.sellerNickName" placeholder="可选" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <el-tabs v-model="activeStatusTab" type="card" class="secondhand-order-tabs" @tab-click="handleStatusTabClick">
      <el-tab-pane v-for="t in statusTabs" :key="t.name" :label="t.label" :name="t.name" />
    </el-tabs>

    <el-table
      class="secondhand-order-table"
      :data="tableData"
      border
      style="width: 100%; margin-top: 12px"
      v-loading="loading"
    >
      <el-table-column prop="orderNo" label="订单号" min-width="180" align="center" />
      <el-table-column prop="productTitle" label="商品标题" min-width="220" show-overflow-tooltip />
      <el-table-column label="支付金额(元)" width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.totalAmount) }}</template>
      </el-table-column>
      <el-table-column label="商品价格(元)" width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.price) }}</template>
      </el-table-column>
      <el-table-column label="运费(元)" width="110" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.freight) }}</template>
      </el-table-column>
      <el-table-column label="支付时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.payTime) }}</template>
      </el-table-column>
      <el-table-column prop="buyerNickName" label="买家" width="140" align="center" show-overflow-tooltip />
      <el-table-column prop="sellerNickName" label="卖家" width="140" align="center" show-overflow-tooltip />
      <el-table-column prop="createTime" label="创建时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <span :style="{ color: statusColor(scope.row.status) }">{{ statusLabel(scope.row.status, scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="detailFn(scope.row)">详情</el-button>
          <el-button
            v-if="canReverseRefund(scope.row)"
            type="danger"
            plain
            size="small"
            style="margin-left: 6px"
            @click="openReverseRefundDialog(scope.row)"
          >未分账退款</el-button>
          <el-button
            v-if="canDivRefund(scope.row)"
            type="warning"
            plain
            size="small"
            style="margin-left: 6px"
            @click="openDivRefundDialog(scope.row)"
          >已分账退款</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page_box">
      <el-pagination
        @current-change="changePage"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal"
      />
    </div>

    <el-dialog title="订单详情" :visible.sync="detailVisible" width="920px" custom-class="secondhand-order-detail-dialog">
      <div v-if="detail" class="detail-dialog-body">
        <section class="detail-section detail-section--product">
          <div class="detail-product-card">
            <div class="detail-product-card__img-wrap">
              <el-image
                v-if="detail.productImage"
                class="detail-product-card__img"
                :src="detail.productImage"
                fit="cover"
                :preview-src-list="[detail.productImage]"
              />
              <div v-else class="detail-product-card__placeholder">暂无主图</div>
            </div>
            <div class="detail-product-card__meta">
              <div class="detail-product-card__title">{{ detail.productTitle || "—" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">订单信息</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">订单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.orderNo || "-" }}</span>
                <el-button v-if="detail.orderNo" class="detail-copy-btn" type="text" @click="copyText(detail.orderNo)">复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">状态</div>
              <div class="detail-field-value">
                <el-tag size="mini" :type="statusTagType(detail.status)">{{ statusLabel(detail.status, detail) }}</el-tag>
                <span v-if="detail.useInspection === 1" style="margin-left: 8px">
                  <el-tag size="mini" type="info">安心购</el-tag>
                </span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付金额(元)</div>
              <div class="detail-field-value">
                <span class="detail-money detail-money--primary">{{ formatMoney(detail.totalAmount) }}</span>
                <span style="margin-left: 10px">
                  <el-tag size="mini" :type="detail.isPay === 1 ? 'success' : 'warning'">{{ detail.isPay === 1 ? "已支付" : "未支付" }}</el-tag>
                </span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">商品价格(元)</div>
              <div class="detail-field-value">
                <span class="detail-money">{{ formatMoney(detail.price) }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">运费(元)</div>
              <div class="detail-field-value">
                <span class="detail-money">{{ formatMoney(detail.freight) }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">保证金(元)</div>
              <div class="detail-field-value">
                <span class="detail-money">{{ detail.deposit == null ? "-" : formatMoney(detail.deposit) }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付时间</div>
              <div class="detail-field-value">{{ formatTime(detail.payTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付截止</div>
              <div class="detail-field-value">{{ formatTime(detail.payExpireTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">创建时间</div>
              <div class="detail-field-value">{{ formatTime(detail.createTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">确认收货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.confirmTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">更新时间</div>
              <div class="detail-field-value">{{ formatTime(detail.updateTime) }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full" v-if="detail.remark">
              <div class="detail-field-label">备注</div>
              <div class="detail-field-value detail-field-value--multiline">{{ detail.remark }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">支付信息</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">微信交易单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.transactionId || "-" }}</span>
                <el-button
                  v-if="detail.transactionId"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(detail.transactionId)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">交易单订单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.combineOutTradeNo || "-" }}</span>
                <el-button
                  v-if="detail.combineOutTradeNo"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(detail.combineOutTradeNo)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">预支付ID</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.prepayId || "-" }}</span>
                <el-button
                  v-if="detail.prepayId"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(detail.prepayId)"
                >复制</el-button>
              </div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">买卖双方</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">买家</div>
              <div class="detail-field-value detail-field-value--party">
                <el-avatar v-if="detail.buyerPhoto" class="detail-party-avatar" :size="36" :src="detail.buyerPhoto" />
                <span>{{ detail.buyerNickName || "-" }} / {{ detail.buyerName || "-" }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">卖家</div>
              <div class="detail-field-value detail-field-value--party">
                <el-avatar v-if="detail.sellerPhoto" class="detail-party-avatar" :size="36" :src="detail.sellerPhoto" />
                <span>{{ detail.sellerNickName || "-" }} / {{ detail.sellerName || "-" }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">买家收货地址</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">收货人</div>
              <div class="detail-field-value">{{ buyerAddrSnap(detail).name || detail.buyerName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">联系电话</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ buyerAddrSnap(detail).phone || detail.buyerPhone || "-" }}</span>
                <el-button
                  v-if="buyerAddrSnap(detail).phone || detail.buyerPhone"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(buyerAddrSnap(detail).phone || detail.buyerPhone)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">详细地址</div>
              <div class="detail-field-value detail-field-value--multiline">{{ buyerAddrSnap(detail).full || detail.buyerAddress || "-" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">卖家发货地址</h4>
          <div class="detail-field-box detail-field-box--cols2">
            <div class="detail-field-cell">
              <div class="detail-field-label">寄件人</div>
              <div class="detail-field-value">{{ sellerAddrSnap(detail).name || detail.sellerName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">联系电话</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ sellerAddrSnap(detail).phone || detail.sellerPhone || "-" }}</span>
                <el-button
                  v-if="sellerAddrSnap(detail).phone || detail.sellerPhone"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(sellerAddrSnap(detail).phone || detail.sellerPhone)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">详细地址</div>
              <div class="detail-field-value detail-field-value--multiline">{{ sellerAddrSnap(detail).full || detail.sellerAddress || "-" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">发货物流（卖家 → 买家）</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">物流公司</div>
              <div class="detail-field-value">{{ detail.logisticsCompany || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">物流单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.logisticsNo || "-" }}</span>
                <el-button v-if="detail.logisticsNo" class="detail-copy-btn" type="text" @click="copyText(detail.logisticsNo)">复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">发货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.shipTime) }}</div>
            </div>
          </div>
        </section>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑订单" :visible.sync="editVisible" width="760px" custom-class="secondhand-order-edit-dialog">
      <div v-loading="editLoading">
        <el-form v-if="editForm" ref="editFormRef" :model="editForm" label-width="120px">
          <el-form-item label="订单号">
            <el-input v-model="editForm.orderNo" disabled />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="editForm.status" placeholder="请选择" style="width: 100%">
              <el-option v-for="s in statusOptions" :key="String(s.value)" :label="s.label" :value="s.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="物流公司">
            <el-input v-model="editForm.logisticsCompany" placeholder="例如：顺丰 / 圆通" />
          </el-form-item>
          <el-form-item label="物流单号">
            <el-input v-model="editForm.logisticsNo" placeholder="请输入物流单号" />
          </el-form-item>
          <el-form-item label="发货时间">
            <el-date-picker v-model="editForm.shipTime" type="datetime" placeholder="选择发货时间" style="width: 100%" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="editForm.remark" type="textarea" :rows="3" placeholder="可选" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="editSubmitLoading" @click="submitEditFn">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="汇付未分账退款（支付撤销）"
      :visible.sync="reverseRefundVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form ref="reverseRefundFormRef" :model="reverseRefundForm" label-width="110px">
        <el-form-item label="订单号">
          <el-input :value="(reverseRefundOrder && reverseRefundOrder.orderNo) || '-'" disabled />
        </el-form-item>
        <el-form-item label="支付金额(元)">
          <el-input :value="formatMoney(reverseRefundOrder && reverseRefundOrder.totalAmount)" disabled />
        </el-form-item>
        <el-form-item label="退款金额(元)">
          <el-input v-model.trim="reverseRefundForm.refundAmount" placeholder="不填默认全额退款" />
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input
            v-model.trim="reverseRefundForm.reason"
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            placeholder="选填"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reverseRefundVisible = false">取消</el-button>
        <el-button type="primary" :loading="reverseRefundSubmitLoading" @click="submitReverseRefund">确认退款</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="汇付已分账退款（创建退款对象）"
      :visible.sync="divRefundVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form ref="divRefundFormRef" :model="divRefundForm" label-width="110px">
        <el-form-item label="订单号">
          <el-input :value="(divRefundOrder && divRefundOrder.orderNo) || '-'" disabled />
        </el-form-item>
        <el-form-item label="支付金额(元)">
          <el-input :value="formatMoney(divRefundOrder && divRefundOrder.totalAmount)" disabled />
        </el-form-item>
        <el-form-item label="退款金额(元)">
          <el-input v-model.trim="divRefundForm.refundAmount" placeholder="不填默认全额退款" />
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input
            v-model.trim="divRefundForm.reason"
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            placeholder="选填"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="divRefundVisible = false">取消</el-button>
        <el-button type="primary" :loading="divRefundSubmitLoading" @click="submitDivRefund">确认退款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  data() {
    return {
      historyArr: ["闲置订单管理", "闲置订单"],
      loading: false,

      activeStatusTab: "all",
      statusTabs: [
        { label: "全部", name: "all", value: null },
        { label: "待支付", name: "0", value: 0 },
        { label: "待发货", name: "1", value: 1 },
        { label: "待收货", name: "2", value: 2 },
        { label: "待评价", name: "3", value: 3 },
        { label: "已完成", name: "4", value: 4 },
        { label: "已退款", name: "5", value: 5 },
        { label: "已取消", name: "6", value: 6 },
      ],
      statusOptions: [
        { label: "全部", value: null },
        { label: "待支付", value: 0 },
        { label: "待发货", value: 1 },
        { label: "待收货", value: 2 },
        { label: "待评价", value: 3 },
        { label: "已完成", value: 4 },
        { label: "已退款", value: 5 },
        { label: "已取消", value: 6 },
      ],

      query: {
        status: null,
        orderNo: "",
        buyerNickName: "",
        sellerNickName: "",
      },

      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      detailVisible: false,
      detail: null,

      editVisible: false,
      editLoading: false,
      editSubmitLoading: false,
      editForm: null,
      reverseRefundVisible: false,
      reverseRefundSubmitLoading: false,
      reverseRefundOrder: null,
      reverseRefundForm: {
        refundAmount: "",
        reason: "",
      },
      divRefundVisible: false,
      divRefundSubmitLoading: false,
      divRefundOrder: null,
      divRefundForm: {
        refundAmount: "",
        reason: "",
      },
    };
  },

  mounted() {
    this.syncTabFromStatus();
    this.fetchList(1);
  },

  watch: {
    "query.status": function () {
      this.syncTabFromStatus();
    },
  },

  methods: {
    statusLabel(v, row) {
      // 保持闲置订单 status 枚举口径（0-6）；安心购流程细分看 inspectionFlowStatus
      const x = Number(v);
      const useInspection = Number((row && row.useInspection) || 0);
      const fs = Number((row && row.inspectionFlowStatus) || 0);
      // 安心购：卖家发货到平台阶段（1-4），即便 status=2 也视为“待发货至买家”
      if (useInspection === 1 && x === 2 && fs > 0 && fs < 5) return "待发货";
      // 安心购内部态：按“待发货”展示
      if (x === 8) return "待发货";
      const m = {
        0: "待支付",
        1: "待发货",
        2: "待收货",
        3: "待评价",
        4: "已完成",
        5: "已退款",
        6: "已取消",
      };
      return m[x] != null ? m[x] : String(v == null ? "-" : v);
    },

    statusColor(v) {
      if (v === 0) return "#e6a23c";
      if (v === 4) return "#67c23a";
      if (v === 5 || v === 6) return "#909399";
      return "#333";
    },

    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return Number.isNaN(n) ? String(v) : n.toFixed(2);
    },

    statusTagType(v) {
      const x = Number(v);
      if (x === 0) return "warning";
      if (x === 4) return "success";
      if (x === 5 || x === 6) return "info";
      return "";
    },

    copyText(text) {
      const t = text == null ? "" : String(text);
      if (!t) return;
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(t)
          .then(() => this.$message.success("已复制"))
          .catch(() => this.fallbackCopyText(t));
        return;
      }
      this.fallbackCopyText(t);
    },

    fallbackCopyText(t) {
      try {
        const el = document.createElement("textarea");
        el.value = t;
        el.setAttribute("readonly", "readonly");
        el.style.position = "fixed";
        el.style.left = "-9999px";
        el.style.top = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        this.$message.success("已复制");
      } catch (e) {
        this.$message.warning("复制失败，请手动复制");
      }
    },

    safeJsonParse(str) {
      if (!str) return null;
      try {
        return JSON.parse(String(str));
      } catch (e) {
        return null;
      }
    },

    normalizeAddressSnapshot(o) {
      if (!o || typeof o !== "object") return { name: "", phone: "", full: "" };
      const pick = (keys) => {
        for (const k of keys) {
          const v = o[k];
          if (v != null && String(v).trim()) return String(v).trim();
        }
        return "";
      };
      const name = pick(["name", "userName", "receiverName", "consignee", "buyerName", "sellerName"]);
      const phone = pick(["phone", "mobile", "tel", "receiverPhone", "consigneePhone", "buyerPhone", "sellerPhone"]);
      const province = pick(["province", "provinceName"]);
      const city = pick(["city", "cityName"]);
      let district = "";
      if (Array.isArray(o.area)) {
        district = o.area.map((x) => String(x || "").trim()).filter(Boolean).join("");
      }
      if (!district) {
        district = pick(["area", "district", "districtName", "county", "countyName"]);
      }
      const detail = pick(["detail", "detailAddress", "addressDetail", "street", "addr", "address"]);
      const full = [province, city, district, detail].filter(Boolean).join("");
      return { name, phone, full };
    },

    buyerAddrSnap(d) {
      const o = this.safeJsonParse(d && d.buyerAddressJson);
      return this.normalizeAddressSnapshot(o);
    },

    sellerAddrSnap(d) {
      const o = this.safeJsonParse(d && d.sellerAddressJson);
      return this.normalizeAddressSnapshot(o);
    },

    syncTabFromStatus() {
      if (this.query.status == null) {
        this.activeStatusTab = "all";
        return;
      }
      const s = String(this.query.status);
      const hit = (this.statusTabs || []).find((t) => t.name === s);
      this.activeStatusTab = hit ? hit.name : "all";
    },

    handleStatusTabClick() {
      const hit = (this.statusTabs || []).find((t) => t.name === this.activeStatusTab);
      this.query.status = hit ? hit.value : null;
      this.currentPage = 1;
      this.fetchList(1);
    },

    resetFn() {
      this.query = { status: null, orderNo: "", buyerNickName: "", sellerNickName: "" };
      this.currentPage = 1;
      this.fetchList(1);
    },

    searchFn() {
      this.currentPage = 1;
      this.fetchList(1);
    },

    changePage(p) {
      this.fetchList(p);
    },

    fetchList(page) {
      this.loading = true;
      const obj = {
        page: page || 1,
        size: this.pageSize,
      };
      // “闲置订单”页面仅展示普通闲置订单：排除安心购订单
      obj.useInspection = 0;
      if (this.query.status != null) obj.status = this.query.status;
      const on = String(this.query.orderNo || "").trim();
      if (on) obj.orderNo = on;
      const bn = String(this.query.buyerNickName || "").trim();
      const sn = String(this.query.sellerNickName || "").trim();
      if (bn) obj.buyerNickName = bn;
      if (sn) obj.sellerNickName = sn;

      this.$https(this.$api.api.selSecondhandOrder, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    detailFn(row) {
      if (!row || !row.id) return;
      this.detailVisible = true;
      this.detail = null;
      this.$https(this.$api.api.getSecondhandOrderById, { id: row.id }, "GET").then((res) => {
        if (res.data && res.data.code == 200) {
          this.detail = res.data.data;
        } else {
          this.$message.error((res.data && res.data.msg) || "查询详情失败");
        }
      });
    },

    editFn(row) {
      if (!row || !row.id) return;
      this.editVisible = true;
      this.editLoading = true;
      this.editSubmitLoading = false;
      this.editForm = null;

      this.$https(this.$api.api.getSecondhandOrderById, { id: row.id }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const d = res.data.data || {};
            this.editForm = {
              id: d.id,
              orderNo: d.orderNo,
              status: d.status,
              logisticsCompany: d.logisticsCompany,
              logisticsNo: d.logisticsNo,
              shipTime: d.shipTime || null,
              remark: d.remark,
            };
          } else {
            this.$message.error((res.data && res.data.msg) || "加载订单失败");
            this.editVisible = false;
          }
        })
        .finally(() => {
          this.editLoading = false;
        });
    },

    submitEditFn() {
      if (!this.editForm || !this.editForm.id) return;
      this.editSubmitLoading = true;
      this.$https(this.$api.api.updateSecondhandOrder, this.editForm, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("保存成功");
            this.editVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .finally(() => {
          this.editSubmitLoading = false;
        });
    },
    canReverseRefund(row) {
      if (!row) return false;
      const isPay = Number(row.isPay || 0) === 1;
      const status = Number(row.status);
      // 仅在已支付且未完成/未退款/未取消时展示入口，具体未分账校验以后端为准
      return isPay && (status === 1 || status === 2);
    },
    openReverseRefundDialog(row) {
      if (!row || !row.id) return;
      this.reverseRefundOrder = row;
      this.reverseRefundForm = {
        refundAmount: "",
        reason: "",
      };
      this.reverseRefundSubmitLoading = false;
      this.reverseRefundVisible = true;
    },
    canDivRefund(row) {
      if (!row) return false;
      const isPay = Number(row.isPay || 0) === 1;
      const status = Number(row.status);
      // 买家确认收货后（待评价/已完成）才可能已分账；是否已提现以后端校验为准
      return isPay && (status === 3 || status === 4);
    },
    openDivRefundDialog(row) {
      if (!row || !row.id) return;
      this.divRefundOrder = row;
      this.divRefundForm = {
        refundAmount: "",
        reason: "",
      };
      this.divRefundSubmitLoading = false;
      this.divRefundVisible = true;
    },
    submitReverseRefund() {
      if (!this.reverseRefundOrder || !this.reverseRefundOrder.id) return;
      const rawAmt = String((this.reverseRefundForm && this.reverseRefundForm.refundAmount) || "").trim();
      let refundAmount = null;
      if (rawAmt) {
        const n = Number(rawAmt);
        if (Number.isNaN(n) || n <= 0) {
          this.$message.warning("退款金额需大于0");
          return;
        }
        refundAmount = Number(n.toFixed(2));
      }
      const payload = {
        orderId: this.reverseRefundOrder.id,
        reason: String((this.reverseRefundForm && this.reverseRefundForm.reason) || "").trim(),
      };
      if (refundAmount != null) payload.refundAmount = refundAmount;
      this.reverseRefundSubmitLoading = true;
      this.$https(this.$api.api.huifuReverseRefundSecondhandOrder, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("退款成功");
            this.reverseRefundVisible = false;
            this.fetchList(this.currentPage);
            if (this.detailVisible && this.detail && this.detail.id === this.reverseRefundOrder.id) {
              this.detailFn(this.reverseRefundOrder);
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "退款失败");
          }
        })
        .finally(() => {
          this.reverseRefundSubmitLoading = false;
        });
    },
    submitDivRefund() {
      if (!this.divRefundOrder || !this.divRefundOrder.id) return;
      const rawAmt = String((this.divRefundForm && this.divRefundForm.refundAmount) || "").trim();
      let refundAmount = null;
      if (rawAmt) {
        const n = Number(rawAmt);
        if (Number.isNaN(n) || n <= 0) {
          this.$message.warning("退款金额需大于0");
          return;
        }
        refundAmount = Number(n.toFixed(2));
      }
      const payload = {
        orderId: this.divRefundOrder.id,
        reason: String((this.divRefundForm && this.divRefundForm.reason) || "").trim(),
      };
      if (refundAmount != null) payload.refundAmount = refundAmount;
      this.divRefundSubmitLoading = true;
      this.$https(this.$api.api.huifuDivRefundSecondhandOrder, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("退款成功");
            this.divRefundVisible = false;
            this.fetchList(this.currentPage);
            if (this.detailVisible && this.detail && this.detail.id === this.divRefundOrder.id) {
              this.detailFn(this.divRefundOrder);
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "退款失败");
          }
        })
        .finally(() => {
          this.divRefundSubmitLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .secondhand-order-tabs {
    margin-top: 12px;
    ::v-deep .el-tabs__content {
      display: none;
    }
    ::v-deep .el-tabs__header {
      margin-bottom: 0;
    }
  }

  .topBox {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }

  .topLeft {
    align-items: center;
  }

  .page_box {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }

  .detail-dialog-body {
    max-height: min(560px, calc(100vh - 200px));
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 4px;
    margin-right: -4px;
  }

  .detail-section {
    margin-bottom: 20px;
    &--last {
      margin-bottom: 0;
    }
  }

  .detail-section__title {
    margin: 0 0 10px;
    padding: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    border-left: 3px solid #409eff;
  }

  .detail-section--product {
    margin-bottom: 16px;
  }

  .detail-product-card {
    display: flex;
    align-items: stretch;
    gap: 16px;
    padding: 14px 16px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .detail-product-card__img-wrap {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #ebeef5;
    background: #fff;
  }

  .detail-product-card__img {
    width: 96px;
    height: 96px;
    display: block;
  }

  .detail-product-card__placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #c0c4cc;
  }

  .detail-product-card__meta {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .detail-product-card__title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.5;
    word-break: break-word;
  }

  .detail-field-box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    &--cols2 {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .detail-field-cell {
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: #fff;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    &--full {
      grid-column: 1 / -1;
      width: 100%;
    }
  }

  .detail-field-label {
    flex-shrink: 0;
    padding: 8px 10px;
    background: #f5f7fa;
    color: #606266;
    font-size: 12px;
    line-height: 1.4;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
  }

  .detail-field-value {
    flex: 1;
    min-width: 0;
    width: 100%;
    min-height: 36px;
    padding: 8px 10px;
    font-size: 13px;
    color: #303133;
    line-height: 1.5;
    word-break: break-all;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .detail-field-value--multiline {
    align-items: flex-start;
    white-space: pre-wrap;
  }

  .detail-field-value--party {
    gap: 10px;
  }

  .detail-party-avatar {
    flex-shrink: 0;
  }

  .detail-field-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 12px;
    line-height: 1.4;
    color: #303133;
    word-break: break-all;
  }

  .detail-copy-btn {
    margin-left: 8px;
    padding: 0;
  }

  .detail-money {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  .detail-money--primary {
    font-size: 16px;
    color: #f56c6c;
  }

  .detail-collapse {
    width: 100%;
  }

  .detail-json {
    margin: 0;
    padding: 10px 12px;
    background: #0b1020;
    color: #e5e7eb;
    border-radius: 6px;
    overflow: auto;
    max-height: 220px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 12px;
    line-height: 1.5;
  }

  /* 表格网格线更清晰（含固定列区域，scoped 下用 v-deep） */
  ::v-deep .secondhand-order-table.el-table--border,
  ::v-deep .secondhand-order-table.el-table--group {
    border: 1px solid #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table.el-table--border::after,
  ::v-deep .secondhand-order-table.el-table--group::after,
  ::v-deep .secondhand-order-table .el-table__fixed::before,
  ::v-deep .secondhand-order-table .el-table__fixed-right::before {
    background-color: #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table th.el-table__cell,
  ::v-deep .secondhand-order-table td.el-table__cell {
    border-right: 1px solid #c0c4cc !important;
    border-bottom: 1px solid #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table thead th.el-table__cell {
    background: #fafafa !important;
  }

  ::v-deep .secondhand-order-table .el-table__fixed-right {
    box-shadow: -1px 0 0 #c0c4cc !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/secondhandOrder/index.vue